import { useState } from "react";

/**
 * Custom hook để quản lý shipping location state và handlers
 */
export const useShippingLocation = (provinces, fetchDistricts, fetchWards, setFormData) => {
  const [shippingLocation, setShippingLocation] = useState({
    selectedProvince: null,
    selectedDistrict: null,
    selectedWard: null,
    districts: [],
    wards: [],
  });

  // Handle shipping location selection
  const handleShippingProvinceChange = async (e) => {
    const provinceId = parseInt(e.target.value);
    const province = provinces.find((p) => p.id === provinceId);

 

    // Fetch districts for shipping province
    let shippingDistricts = [];
    if (province) {
      shippingDistricts = await fetchDistricts(provinceId);
    }

    const newShippingLocation = {
      selectedProvince: province,
      selectedDistrict: null,
      selectedWard: null,
      districts: shippingDistricts,
      wards: [],
    };


    setShippingLocation(newShippingLocation);

    // Update form data with selected shipping province
    setFormData((prev) => ({
      ...prev,
      shippingCity: province?.name || "",
      shippingCityId: province?.id || null,
      shippingState: "", // Reset district when province changes
      shippingStateId: null,
      shippingWard: "", // Reset ward when province changes
      shippingWardId: null,
    }));
  };

  const handleShippingDistrictChange = async (e) => {
    const districtId = parseInt(e.target.value);
    const district = shippingLocation.districts.find(
      (d) => d.id === districtId
    );


    // Fetch wards for selected shipping district
    let wardsList = [];
    if (district) {
      wardsList = await fetchWards(districtId);
    }

    const newShippingLocation = {
      ...shippingLocation,
      selectedDistrict: district,
      selectedWard: null, // Reset ward when district changes
      wards: wardsList,
    };


    setShippingLocation(newShippingLocation);

    // Update form data with selected shipping district and reset ward
    setFormData((prev) => ({
      ...prev,
      shippingDistrict: district?.name || "",
      shippingWard: "", // Reset ward when district changes
      shippingWardId: null,
    }));
  };

  // Handle ward selection for shipping
  const handleShippingWardChange = (e) => {
    const wardId = e.target.value; // Không cần parseInt vì WardCode có thể là string
    const ward = shippingLocation.wards.find((w) => w.id == wardId); // Sử dụng == thay vì === để so sánh loose

    const newShippingLocation = {
      ...shippingLocation,
      selectedWard: ward,
    };


    setShippingLocation(newShippingLocation);

    // Update form data with selected shipping ward
    setFormData((prev) => ({
      ...prev,
      shippingWard: ward?.name || "",
      shippingWardId: ward?.id || null,
    }));
  };

  return {
    shippingLocation,
    handleShippingProvinceChange,
    handleShippingDistrictChange,
    handleShippingWardChange,
  };
};
